export const ACL = {
  REGISTER: "REGISTER",
  USER: "USER",
  ROLE: "ROLE",
  ROOM: "ROOM",
  INFORMATION_PAGE: "INFORMATION_PAGE",
  STATISTICS: "STATISTICS",
  COMPANY: "COMPANY",
  BOOKING: "BOOKING",
  ADMIN_PANEL: "ADMIN_PANEL",
  USE_CREDITS: "USE_CREDITS",
}